import { RangeCalendarAvailableView } from '@app/shared/models/ipm/view/RangeCalendarAvailableView';
import { AirlineView } from '@app/shared/models/ipm/view/AirlineView';
import { CountryView } from '@app/shared/models/ipm/view/CountryView';
import { DocumentTypesView } from '@app/shared/models/ipm/view/DocumentTypesView';

export class FilterIPMSelectionView {
    constructor(
        public rangeSelected: RangeCalendarAvailableView,
        public countriesSelected: Array<CountryView>,
        public airlinesSelected: Array<AirlineView>,
        public documentTypesSelected: Array<DocumentTypesView>
    ) { }
}